export const communicationTypeMapping: Record<string, string> = {
    'video': 'Видео',
    'audio': 'Аудио',
    'async_chat': 'Асинхронный чат',
    'sync_chat': 'Синхронный чат'
};

export const consultationTypeMapping: Record<string, string> = {
    'professional': 'Профессиональная',
    'individual': 'Индивидуальная',
    'pair': 'Парная',
    'knowing': 'Начало',
    'expert': 'Экспертная',
};

export const getConsultationTypeLabel = (typeName?: string | null): string => {
    if (!typeName) {
        return '';
    }

    const normalizedName = typeName.trim().toLowerCase();

    return consultationTypeMapping[typeName]
        || consultationTypeMapping[normalizedName]
        || typeName;
};
export const orderStatusMapping: Record<string, string> = {
    'new': 'Не оплачен',
    'paid': 'Оплачен',
    'executed': 'Оплачен',
    'cancelled': 'Отменён',
};